import React, { useState, useEffect } from 'react';
import './login.css'
import { ArrowLeft, Cloud } from 'lucide-react';
import ILogin from './ILogin';
import OtpInput from './OtpInput';
import { useSelector, useDispatch } from 'react-redux';
import { login, cleanLoginError } from '../../redux/action';
import { useNavigate } from "react-router-dom";
import LanguageSelector from '../../component/LanguageSelector/LanguageSelector';
import { ButtonLoader } from '../../component/common/Loader';
import PasswordInput from '../../component/common/PasswordInput';

const LoginPage = () => {
    const [otpStage, setOtpStage] = useState(false);
    const [phoneNo, setPhoneNo] = useState(false);
    const [restaurantId, setRestaurantId] = useState(false);
    // const restaurant = useSelector((state) => state?.user?.menu.restaurantName) || "Restaurant Admin";
    const [forgatePassword, setForgatePassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    //  const user =  useSelector((state) => state.restros);
    // const restros = useSelector((state) => state.user?.restros);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleBackToLogin = () => {
        setForgatePassword(false);
        setOtpStage(false);
        setPhoneNo(false);
        setRestaurantId(false);
    };

    const handleLogin = (e) => {
        if (e) e.preventDefault();
        if (loading) return;   // prevent multiple clicks
        setLoading(true);

        try {
            dispatch(cleanLoginError())
            dispatch(login({ username, password }));
        } catch (error) {
            console.error("Login failed:", error.message);
            setLoading(false);
        }

    };
    const loginError = useSelector((state) => state.user?.loginError);

    useEffect(() => {
        if (loginError)
            setLoading(false);
    }, [loginError]);


    // useEffect(() => {
    //     if (restros) {
    //     console.log("triggered useEffect........", restros); 
    //     console.log("useEffect main:", restros); 
    //     navigate("/main", { state: { restros } });
    //     }
    // }, [restros]);


    return (
        <main className="auth-page">
            <LanguageSelector className="auth-language-selector auth-language-selector--desktop" />
            <div className="auth-mobile-header">
                <div className="auth-mobile-logo"><Cloud aria-hidden="true" /><span>Menu Zyka</span></div>
                <LanguageSelector className="auth-language-selector--mobile" />
            </div>
            <div className="auth-shell">
                <aside className="auth-brand" aria-label="Menu Zyka">
                    <div className="auth-logo"><Cloud aria-hidden="true" /><span>Menu Zyka</span></div>
                    <div className="auth-brand-copy">
                        <h2>Great service<br />starts here.</h2>
                        <p>Your restaurant. One workspace.</p>
                    </div>
                    <p className="auth-brand-footer">Good food.<br />Brighter tomorrows.</p>
                </aside>
                <section className="auth-panel" aria-labelledby="auth-title">
                    <div className="auth-content">
                        {forgatePassword && (
                            <button type="button" className="auth-back" onClick={handleBackToLogin}>
                                <ArrowLeft size={18} aria-hidden="true" />
                                <span>Back to sign in</span>
                            </button>
                        )}
                        <h1 id="auth-title">{forgatePassword ? 'Forgot Password' : 'Welcome back'}</h1>
                        <p className="auth-description">{forgatePassword ? 'Recover access to your restaurant workspace.' : 'Sign in to manage your restaurant.'}</p>
                        <div className="login-form">
                            {!forgatePassword ? (
                                <form onSubmit={handleLogin}>
                                    <div className="auth-field">
                                        <label htmlFor="login-phone">Phone number</label>
                                        <input id="login-phone" type="tel" autoComplete="username"
                                            placeholder="Registered Phone Number" className="loginInput"
                                            value={username} onChange={e => setUsername(e.target.value)} />
                                    </div>
                                    <div className="auth-field">
                                        <label htmlFor="login-password">Password</label>
                                        <PasswordInput id="login-password" autoComplete="current-password"
                                            placeholder="Password" className="loginInput"
                                            value={password} onChange={e => setPassword(e.target.value)} />
                                    </div>
                                    <div className="auth-forgot">
                                        <button type="button" className="auth-link" onClick={() => setForgatePassword(true)}>Forgot password?</button>
                                    </div>
                                    <button type="submit" disabled={loading} className="full-btn auth-submit" aria-busy={loading}>
                                        {loading ? <ButtonLoader label="Signing in..." /> : 'Sign in'}
                                    </button>
                                </form>
                            ) : (
                                <div className="auth-recovery">
                                    {otpStage ? <OtpInput phoneNo={phoneNo} restaurantId={restaurantId} /> : <ILogin setOtpStage={setOtpStage} setPhoneNo={setPhoneNo} setRestaurantId={setRestaurantId} />}
                                </div>
                            )}
                        </div>
                    </div>
                    <p className="auth-footer">Restaurant management, simplified.</p>
                </section>
            </div>
        </main>
    );
};

export default LoginPage;
